import { render, staticRenderFns } from "./StorageBaseComposition.vue?vue&type=template&id=c8328994&"
import script from "./StorageBaseComposition.vue?vue&type=script&lang=js&"
export * from "./StorageBaseComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports